import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ManPowerComponent } from '../man-power/man-power.component';
import { DailyManPowerLocationAssignComponent } from './daily-man-power-location-assign/daily-man-power-location-assign.component';
import { ManPowerListComponent } from './man-power-list/man-power-list.component';
import { ManPowerLocationComponent } from './man-power-location/man-power-location/man-power-location.component';
import { ManPowerUnassignComponent } from './man-power-unassign/man-power-unassign.component';
import { FilterManPowerAssignComponent } from './filter-man-power-assign/filter-man-power-assign.component';
import { ManpowerOTApprovalComponent } from './ot-approval-list/ot-approval-list.component';
import { AuthGuard } from '../auth.guard';


const routes: Routes = [
  {
    path: 'man-power',
    component: ManPowerListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'man-power1',
    component: ManPowerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'manpower-location-assign',
    component: DailyManPowerLocationAssignComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'man-power-location',
    component: ManPowerLocationComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'man-power-unassign',
    component: ManPowerUnassignComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'man-power-location-assign',
    component: FilterManPowerAssignComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'ot-approval',
    component: ManpowerOTApprovalComponent,
    canActivate: [AuthGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManPowerRoutingModule { }
